/* Protección de envío: de schakelaar in de cart-la (Prestige). Overgezet van Tanzanix/Noirski, met drie verschillen:
   - variant en "automatisch aan" komen uit het script-element in layout/theme.liquid (data-variant-id, data-auto),
     er staat geen id vast in de code;
   - automatisch toevoegen gebeurt ALLEEN met data-auto="true" (Theme settings > Cart). Staat het uit, dan zet alleen
     de klant de bescherming aan;
   - de la wordt hier niet zelf opnieuw getekend: het thema tekent la, teller en stip opnieuw op cart:refresh.
     (Het origineel vroeg daarvoor een sectie op die niet bestaat, op elke pagina.) */
(function () {
  const script = document.currentScript;
  const VARIANT_ID = Number(script && script.dataset.variantId);
  if (!VARIANT_ID) return;
  const AUTO = script.dataset.auto === 'true';
  const SWITCH_SELECTOR = '#switch2, #switch3';
  const SAFETY_UNLOCK_MS = 15000;
  const OPT_OUT_KEY = 'rz_proteccion_opt_out';

  let previousNormalItemCount = Number(script.dataset.count) || 0;
  let hasInitialized = false;
  let activeOperations = 0;
  let safetyUnlockTimer = null;

  /* Automatisch toevoegen alleen als een afmelding onthouden kan worden. */
  function autoAddAllowed() {
    if (!AUTO) return false;
    try { return sessionStorage.getItem(OPT_OUT_KEY) !== '1'; } catch (e) { return false; }
  }

  function rememberChoice(isOn) {
    try { if (isOn) sessionStorage.removeItem(OPT_OUT_KEY); else sessionStorage.setItem(OPT_OUT_KEY, '1'); } catch (e) {}
  }

  function isProcessing() {
    return activeOperations > 0;
  }

  /* De schakelaar staat vast zolang een cart-actie loopt, zodat hij niet twee keer omgezet kan worden. */
  function applyLockState() {
    const locked = isProcessing();
    document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => {
      s.disabled = locked;
      s.classList.toggle('syncing', locked);
      const label = s.closest('.switch');
      if (label) label.classList.toggle('switch--disabled', locked);
    });
  }

  function beginOperation() {
    activeOperations += 1;
    applyLockState();

    if (safetyUnlockTimer) clearTimeout(safetyUnlockTimer);
    safetyUnlockTimer = setTimeout(() => {
      safetyUnlockTimer = null;
      activeOperations = 0;
      applyLockState();
    }, SAFETY_UNLOCK_MS);
  }

  function endOperation() {
    activeOperations = Math.max(0, activeOperations - 1);

    if (activeOperations === 0 && safetyUnlockTimer) {
      clearTimeout(safetyUnlockTimer);
      safetyUnlockTimer = null;
    }

    applyLockState();
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
  }

  function cartHasProtection(cart) {
    return cart.items.some((item) => item.variant_id === VARIANT_ID);
  }

  function normalItemQuantity(cart) {
    return cart.items.reduce((sum, item) => (item.variant_id === VARIANT_ID ? sum : sum + item.quantity), 0);
  }

  function updateToggleState(cart) {
    const on = cartHasProtection(cart);
    document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => { s.checked = on; });
  }

  /* Het thema (cart-drawer, cart-count, cart-dot) tekent zichzelf opnieuw op cart:refresh. */
  function askThemeToRefresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function showCheckoutLoader() {
    const priceSpan = document.querySelector('.cart-summary__row--total span:last-child');
    if (!priceSpan || priceSpan.dataset.loading) return;
    priceSpan.dataset.loading = 'true';
    priceSpan.classList.add('loading-price');
    priceSpan.innerHTML = '<span class="price-loader"><span class="price-loader__dot"></span><span class="price-loader__dot"></span><span class="price-loader__dot"></span></span>';
  }

  function post(url, params) {
    const body = new URLSearchParams();
    Object.keys(params).forEach((k) => body.append(k, params[k]));
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + url, { method: 'POST', body: body, headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error(url + ' ' + response.status);
      return response.json();
    });
  }

  function addPackageProtection() {
    showCheckoutLoader();
    return post('cart/add.js', { id: VARIANT_ID, quantity: '1' });
  }

  function removePackageProtection() {
    showCheckoutLoader();
    return fetchCart().then((cart) => {
      const protectionItem = cart.items.find((item) => item.variant_id === VARIANT_ID);
      if (!protectionItem) return cart;
      return post('cart/change.js', { id: protectionItem.key, quantity: '0' });
    });
  }

  /* Na elke wijziging van de cart: staat de bescherming er nog goed in? */
  function runCartUpdate() {
    return fetchCart().then((cart) => {
      const normalQty = normalItemQuantity(cart);
      const hasProtection = cartHasProtection(cart);
      const first = !hasInitialized;
      hasInitialized = true;

      /* Alleen de bescherming over: die hoort niet alleen in de cart te blijven. */
      if (normalQty === 0 && hasProtection) {
        previousNormalItemCount = 0;
        return removePackageProtection().then(askThemeToRefresh);
      }

      /* Automatisch aan (alleen met data-auto="true"): bij laden met een gevulde cart, of als er een product bijkomt. */
      if (!hasProtection && autoAddAllowed() && normalQty > 0 && (first || normalQty > previousNormalItemCount)) {
        previousNormalItemCount = normalQty;
        return addPackageProtection().then(askThemeToRefresh);
      }

      previousNormalItemCount = normalQty;
      updateToggleState(cart);
    }).catch((error) => {
      console.error('Protección de envío: bijwerken mislukt:', error);
    });
  }

  function updateCartAndDrawer() {
    beginOperation();
    return runCartUpdate().then(endOperation, endOperation);
  }

  function handleSwitchChange(evt) {
    const switchElement = evt.target;

    /* Vangnet: een wijziging die doorglipt terwijl er nog een actie loopt. */
    if (isProcessing()) {
      switchElement.checked = !switchElement.checked;
      applyLockState();
      return;
    }

    const isTurningOn = switchElement.checked;
    rememberChoice(isTurningOn);
    beginOperation();

    (isTurningOn ? addPackageProtection() : removePackageProtection())
      .then(() => { endOperation(); askThemeToRefresh(); })
      .catch((error) => {
        console.error('Protección de envío: schakelaar mislukt, teruggezet:', error);
        document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => { s.checked = !isTurningOn; });
        endOperation();
        askThemeToRefresh();
      });
  }

  document.addEventListener('change', (evt) => {
    if (evt.target && (evt.target.id === 'switch2' || evt.target.id === 'switch3')) handleSwitchChange(evt);
  });

  /* Klikken op de schakelaar tellen niet zolang er nog een actie loopt. */
  document.addEventListener('click', (evt) => {
    if (!isProcessing()) return;
    const target = evt.target;
    if (target.closest && (target.closest('.package-protection-btn') || target.closest('.switch'))) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  }, true);

  document.addEventListener('cart:change', updateCartAndDrawer);
  document.addEventListener('cart:refresh', updateCartAndDrawer);

  /* Bij het laden alleen de cart opvragen als dat iets kan opleveren: automatisch aan, of de bescherming zit er al in.
     Anders kost elke paginaweergave een verzoek dat niets doet. */
  const start = () => {
    if (AUTO || script.dataset.inCart === 'true') updateCartAndDrawer();
    else hasInitialized = true;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
